import { InputBase, Theme, styled } from '@material-ui/core';

const CustomInput = styled(InputBase)<Theme>(({ theme }) => ({
  flex: 1,
  position: 'inherit',
  fontSize: theme.typography.h4.fontSize,
  marginLeft: theme.spacing(1),
}));

export default CustomInput;
